import { createContext, useContext, useState, useEffect } from 'react';

const CURRENCIES = {
  INR: { symbol: '₹', name: 'Indian Rupee' },
  USD: { symbol: '$', name: 'US Dollar' },
  GBP: { symbol: '£', name: 'British Pound' },
  EUR: { symbol: '€', name: 'Euro' },
  AED: { symbol: 'د.إ', name: 'UAE Dirham' },
  SGD: { symbol: 'S$', name: 'Singapore Dollar' },
  AUD: { symbol: 'A$', name: 'Australian Dollar' },
  CAD: { symbol: 'C$', name: 'Canadian Dollar' }
};

const CurrencyContext = createContext(null);

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    return localStorage.getItem('chaleur_currency') || 'INR';
  });

  // Always default to INR - user can change manually if needed
  useEffect(() => {
    if (!localStorage.getItem('chaleur_currency')) {
      localStorage.setItem('chaleur_currency', 'INR');
    }
  }, []);

  const changeCurrency = (newCurrency) => {
    if (CURRENCIES[newCurrency]) {
      setCurrency(newCurrency);
      localStorage.setItem('chaleur_currency', newCurrency);
    }
  };

  const formatPrice = (amount, currencyCode = currency) => {
    const curr = CURRENCIES[currencyCode] || CURRENCIES.INR;
    return `${curr.symbol}${amount?.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }) || '0'}`;
  };

  return (
    <CurrencyContext.Provider value={{
      currency,
      currencies: CURRENCIES,
      changeCurrency,
      formatPrice,
      symbol: CURRENCIES[currency]?.symbol || '₹'
    }}>
      {children}
    </CurrencyContext.Provider>
  );
};
